import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    generalFinanceAll: [],
    generalFinance: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const generalFinanceSlice = createSlice({
    name: "generalFinance",
    initialState,
    reducers: {
        setGeneralFinanceAll: (state, action) => {
            state.generalFinanceAll = action.payload;
        },
        setGeneralFinance: (state, action) => {
            state.generalFinance = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const { 
    setGeneralFinanceAll, 
    setGeneralFinance, 
    setCurrentPage, 
    setTotalPages, 
    setRowsPerPage 
} = generalFinanceSlice.actions;

export default generalFinanceSlice.reducer;
